import { __decorate } from "tslib";
import { Component, HostListener, ViewChild, ViewEncapsulation } from '@angular/core';
import { SharedHttp } from '../../../services/http-client.service';
import { AuthService } from '../../../services/auth.service';
import { Router } from '@angular/router';
import { PaymentService } from '../../../services/payment.service';
import { SpinnerService } from '../../spinner/spinner.service';
import { WebClientService } from '../../../services/webclient-settings.service';
import { WebsiteThemeService } from '../../../services/website-theme.service';
import { DomSanitizer } from '@angular/platform-browser';
import { EcurrenciesService } from '../../../services/ecurrencies.service';
import { UtilityService } from '../../../services/utility.service';
/**
 * Home Component
 */
let CreateTransactionComponent = class CreateTransactionComponent {
    constructor(httpClient, router, auth, paymentService, spinner, webSettingsService, sanitizer, themeService, checker, ecurrenciesService) {
        this.httpClient = httpClient;
        this.router = router;
        this.auth = auth;
        this.paymentService = paymentService;
        this.spinner = spinner;
        this.webSettingsService = webSettingsService;
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.checker = checker;
        this.ecurrenciesService = ecurrenciesService;
        this.txData = {};
        this.currentPrice = 0;
        this.orderMessage = '';
        this.resultOfService = [];
        this.userType = 'guest';
        this.allFeesLimits = {};
        this.tabLoading = false;
        this.orderState = '';
        this.sentEmailMessage = false;
        this.confirmationMessage = '';
        this.confirmationMessageError = '';
        this.limitValue = '';
        this.textColor = '';
        this.errorColor = '';
        this.successColor = '';
        this.mainColor = '';
        this.linkColor = '';
        this.secondColor = '';
        this.inputBackColor = '';
        this.inputTextColor = '';
        this.tabColor = '';
        this.accentColor = '';
        this.firstColor = '';
        this.backColor = '';
        this.ecurrencies = [];
        this.emailError = false;
        this.nameError = false;
        this.mobileError = false;
        this.disabledTxMOP = false;
        this.isActiveTxMOP = true;
        this.disabledTx = false;
        this.guestData = [];
        this.isGuest = true;
        this.clicked = false;
        this.errorInForm = false;
        this.borderRadiusSmaller = '';
        this.borderRadiusLarger = '';
        this.showCurrency = false;
        this.webSettingsService.getSettings().subscribe(data => {
            if (!this.webSettingsService.applySettings('GUEST_USER.ON')) {
                this.router.navigate(['/']);
            }
        });
        this.auth.fetchUser().then(result => {
            this.isGuest = !result;
        });
        this.themeService.getTheme().subscribe((data) => {
            this.accentColor = this.themeService.getStyleAttribute('accent_color');
            this.firstColor = this.themeService.getStyleAttribute('currency_ring_two_color');
            this.secondColor = this.themeService.getStyleAttribute('currency_ring_one_color');
            this.backColor = this.themeService.getStyleAttribute('side_menu');
            this.textColor = this.themeService.getStyleAttribute('text_color');
            this.tabColor = this.themeService.getStyleAttribute('tab_color');
            this.mainColor = this.themeService.getStyleAttribute('main_color');
            this.inputTextColor = this.themeService.getStyleAttribute('input_text_color');
            this.inputBackColor = this.themeService.getStyleAttribute('input_background_color');
            this.linkColor = this.themeService.getStyleAttribute('link_color');
            this.successColor = this.themeService.getStyleAttribute('success_color');
            this.errorColor = this.themeService.getStyleAttribute('error_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
        });
        this.spinner.start();
        this.tabLoading = true;
        this.activeMeanOfPayment = 'bank_slip';
        this.ecurrenciesService.getEcurrencies().then((data) => {
            this.ecurrencies = this.ecurrenciesService.getAllEcurrencies();
            this.numberOfEcurrencies = this.ecurrencies.length;
            this.currency = this.ecurrencies[0].code;
            this.tabLoading = false;
            this.spinner.stop();
            const currency = sessionStorage.getItem('chosenCurrency');
            let j = 0;
            if (currency) {
                for (let i = 0; i < this.numberOfEcurrencies; i++) {
                    if (currency === this.ecurrencies[i].code) {
                        this.setCurrency(currency);
                        j = 1;
                        break;
                    }
                }
                if (j === 0) {
                    this.setCurrency(this.currency);
                }
            }
            else {
                this.setCurrency(this.currency);
            }
            const type = sessionStorage.getItem('chosenType');
            if (type) {
                if (type === 'buy' || type === 'sell') {
                    this.setType(type);
                }
                else {
                    this.setType('buy');
                }
            }
            else {
                this.setType('buy');
            }
        });
    }
    ngOnInit() {
        var scrollStep = -window.scrollY / (100 / 15), scrollInterval = setInterval(function () {
            if (window.scrollY != 0) {
                window.scrollBy(0, scrollStep);
            }
            else
                clearInterval(scrollInterval);
        }, 15);
    }
    ngOnDestroy() {
        sessionStorage.removeItem('chosenType');
        sessionStorage.removeItem('chosenCurrency');
    }
    clickCurrency() {
        this.showCurrency = !this.showCurrency;
    }
    onDocumentClick(event) {
        const targetElement = event.target;
        if (targetElement.className !== 'currencySelected' &&
            targetElement.className !== 'currencySelectOptions' &&
            targetElement.className !== 'currencySelect') {
            this.closeCurrency();
        }
    }
    closeCurrency() {
        this.showCurrency = false;
    }
    getFeesAndLimits() {
        this.httpClient.get('market/feesandlimits').subscribe((data) => {
            this.allFeesLimits = data;
            const feesForCurrency = this.allFeesLimits[this.type][this.currency];
            if (feesForCurrency !== undefined) {
                if (this.activeMeanOfPayment in feesForCurrency) {
                    if (this.userType in feesForCurrency[this.activeMeanOfPayment]) {
                        const activeFees = feesForCurrency[this.activeMeanOfPayment][this.userType];
                        this.provision = parseFloat(activeFees.fee);
                        this.minAmount = parseFloat(activeFees.min_amount);
                        this.maxAmount = parseFloat(activeFees.max_amount);
                        this.disabledTx = activeFees.disabled;
                        this.disabledTxMOP = activeFees.disabled_mop;
                    }
                    else {
                        this.provision = null;
                        this.disabledTx = true;
                    }
                }
                else {
                    this.provision = null;
                    this.paymentService.getMeansOfPayment().subscribe(requestData => {
                        this.resultOfService = JSON.parse(requestData['_body']);
                        for (var i = 0; i < this.resultOfService.length; i++) {
                            if (this.activeMeanOfPayment === this.resultOfService[i].verbose_id) {
                                this.disabledTxMOP = this.resultOfService[i].disabled;
                                this.isActiveTxMOP = this.resultOfService[i].is_active;
                            }
                            else {
                                this.disabledTxMOP = true;
                                this.isActiveTxMOP = false;
                            }
                        }
                    }, error => {
                        this.tabLoading = false;
                        this.spinner.stop();
                        console.error(error);
                    });
                }
                this.isOrderAllowed(this.currency, this.type, this.activeMeanOfPayment);
            }
            else {
                this.provision = null;
                this.disabledTx = true;
            }
        }, (error) => {
            this.provision = null;
            this.disabledTx = true;
            this.tabLoading = false;
            this.spinner.stop();
        });
    }
    setType(selected) {
        this.clicked = false;
        if (typeof this.txData.email === 'undefined') {
            this.emailError = false;
        }
        if (typeof this.txData.name === 'undefined') {
            this.nameError = false;
        }
        if (typeof this.txData.mobile === 'undefined') {
            this.mobileError = false;
        }
        if (typeof this.orderForm !== 'undefined') {
            if (typeof this.orderForm.txData.deposit_address === 'undefined') {
                this.orderForm.validDepositAddress = true;
            }
            if (typeof this.orderForm.txData.bank_account === 'undefined') {
                this.orderForm.validBankAccount = true;
            }
            if (typeof this.orderForm.txData.total === 'undefined' && typeof this.orderForm.txData.amount === 'undefined') {
                this.orderForm.validTotalAndAmount = true;
            }
        }
        this.type = selected;
        this.getFeesAndLimits();
        if (!this.disabledTx && !this.disabledTxMOP && this.isActiveTxMOP) {
            this.httpClient.get('order/prices/' + this.currency + '/' + this.type + '?mop=' + this.activeMeanOfPayment).subscribe((result) => {
                this.currentPrice = result['message'];
                this.tabLoading = false;
                this.spinner.stop();
            }, (error) => {
                this.disabledTx = true;
                this.tabLoading = false;
                this.spinner.stop();
            });
        }
    }
    setCurrency(currency) {
        this.clicked = false;
        if (typeof this.txData.email === 'undefined') {
            this.emailError = false;
        }
        if (typeof this.txData.name === 'undefined') {
            this.nameError = false;
        }
        if (typeof this.txData.mobile === 'undefined') {
            this.mobileError = false;
        }
        if (typeof this.orderForm !== 'undefined') {
            if (typeof this.orderForm.txData.deposit_address === 'undefined') {
                this.orderForm.validDepositAddress = true;
            }
            if (typeof this.orderForm.txData.bank_account === 'undefined') {
                this.orderForm.validBankAccount = true;
            }
            if (typeof this.orderForm.txData.total === 'undefined' && typeof this.orderForm.txData.amount === 'undefined') {
                this.orderForm.validTotalAndAmount = true;
            }
        }
        this.allFeesLimits = [];
        this.currency = currency;
        this.getFeesAndLimits();
        if (!this.disabledTx && !this.disabledTxMOP && this.isActiveTxMOP) {
            this.httpClient.get('order/prices/' + this.currency + '/' + this.type + '?mop=' + this.activeMeanOfPayment).subscribe((result) => {
                this.currentPrice = result['message'];
                this.tabLoading = false;
                this.spinner.stop();
            }, (error) => {
                this.disabledTx = true;
                this.tabLoading = false;
                this.spinner.stop();
            });
        }
    }
    validateEmail(email) {
        const reg = /^([A-Za-z0-9_\-\.\+])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,15})$/;
        if (reg.test(email) === false) {
            this.emailError = true;
            return false;
        }
        this.emailError = false;
        return true;
    }
    validateName(name) {
        if (typeof name === 'undefined') {
            this.nameError = true;
            return false;
        }
        else if (name.trim().length < 3 || name.trim().split(' ').length < 2) {
            this.nameError = true;
            return false;
        }
        else {
            this.nameError = false;
            return true;
        }
    }
    validatePhone(mobile) {
        this.mobileError = !this.checker.checkPhone(mobile);
        return !this.mobileError;
    }
    isOrderAllowed(currency, type, mop) {
        this.httpClient.get('market/order/guest/isorderallowed?cryptocurrency=' + currency + '&txtype=' + type + '&mop=' + mop).subscribe((result) => {
            this.orderMessage = result + '';
            this.disabledTx = false;
        }, (error) => {
            this.orderMessage = 'SOME_ERROR';
            this.disabledTx = true;
            console.error(error);
            this.tabLoading = false;
            this.spinner.stop();
        });
    }
    send_email_again() {
        this.confirmationMessage = '';
        this.confirmationMessageError = '';
        this.httpClient.post('market/order/guest/requestconfirm', { id: this.guestData.order_id }).subscribe((success) => {
            this.confirmationMessage = success['message'];
        }, (error) => {
            this.confirmationMessageError = error.error['message'];
        });
    }
    submit() {
        this.auth.fetchUser().then(result => {
            this.isGuest = !result;
            if (this.isGuest) {
                this.validateName(this.txData.name);
                this.validateEmail(this.txData.email);
                this.validatePhone(this.txData.mobile);
                if (typeof this.orderForm !== 'undefined') {
                    this.orderForm.validateBankAccount();
                    this.orderForm.validateTotalAndAmount();
                    this.orderForm.validateAddress();
                    if (this.type === 'sell') {
                        this.errorInForm =
                            !this.orderForm.validateTotalAndAmount() ||
                                !this.orderForm.validateBankAccount() ||
                                !this.validateName(this.txData.name) ||
                                !this.validateEmail(this.txData.email) ||
                                !this.validatePhone(this.txData.mobile);
                    }
                    if (this.type === 'buy') {
                        this.errorInForm =
                            !this.orderForm.validateTotalAndAmount() ||
                                !this.orderForm.validateAddress() ||
                                !this.validateName(this.txData.name) ||
                                !this.validateEmail(this.txData.email) ||
                                !this.validatePhone(this.txData.mobile);
                    }
                    this.guestData = [];
                    const data = this.orderForm.getData();
                    this.txData.deposit_address = data.deposit_address;
                    this.txData.bank_account = data.bank_account;
                    this.txData.amount = data.amount;
                    this.txData.total = data.total;
                    this.txData.cryptocurrency = this.currency;
                    this.txData.mean_of_payment = this.activeMeanOfPayment;
                    this.whatLast = this.orderForm.whatLast;
                    if (this.whatLast === 'amount') {
                        delete this.txData.total;
                    }
                    if (this.whatLast === 'total') {
                        delete this.txData.amount;
                    }
                    if (this.validateName(this.txData.name) &&
                        this.validateEmail(this.txData.email) &&
                        this.validatePhone(this.txData.mobile)) {
                        this.orderForm.validateAddress();
                        if (this.type === 'buy' && this.orderForm.validDepositAddress && this.orderForm.validateTotalAndAmount()) {
                            this.httpClient.post('market/order/guest/buy', this.txData)
                                .subscribe((guestData) => {
                                this.guestData = guestData;
                                localStorage.setItem('orderData', JSON.stringify(this.guestData));
                                localStorage.setItem('currentOrderMeanOfPayment', JSON.stringify(this.guestData.mean_of_payment));
                                localStorage.setItem('orderId', this.guestData.order_id);
                                localStorage.setItem('orderType', 'buy');
                                this.orderState = this.guestData.order_state;
                                if (this.orderState === 'confirmed') {
                                    this.router.navigateByUrl('/tx/confirm/' + this.guestData.order_id);
                                }
                                else if (this.orderState === 'unconfirmed') {
                                    this.sentEmailMessage = true;
                                    var scrollStep = -window.scrollY / (100 / 15), scrollInterval = setInterval(function () {
                                        if (window.scrollY != 0) {
                                            window.scrollBy(0, scrollStep);
                                        }
                                        else
                                            clearInterval(scrollInterval);
                                    }, 15);
                                }
                            }, (error) => {
                                this.orderMessage = error.error['message'];
                                if (this.orderMessage === 'USER_DAILY_LIMIT_EXCEEDED' ||
                                    this.orderMessage === 'USER_WEEKLY_LIMIT_EXCEEDED' ||
                                    this.orderMessage === 'USER_MONTHLY_LIMIT_EXCEEDED') {
                                    this.limitValue = error.error['value'];
                                }
                            });
                        }
                        else if (this.type === 'sell' && this.orderForm.validateBankAccount() && this.orderForm.validateTotalAndAmount()) {
                            this.httpClient.post('market/order/guest/sell', this.txData)
                                .subscribe((guestData) => {
                                this.guestData = guestData;
                                localStorage.setItem('orderData', JSON.stringify(this.guestData));
                                localStorage.setItem('currentOrderMeanOfPayment', JSON.stringify(this.guestData.mean_of_payment));
                                localStorage.setItem('orderId', this.guestData.order_id);
                                localStorage.setItem('orderType', 'sell');
                                this.orderState = this.guestData.order_state;
                                if (this.orderState === 'confirmed') {
                                    this.router.navigateByUrl('/tx/confirm/' + this.guestData.order_id);
                                }
                                else if (this.orderState === 'unconfirmed') {
                                    this.sentEmailMessage = true;
                                    var scrollStep = -window.scrollY / (100 / 15), scrollInterval = setInterval(function () {
                                        if (window.scrollY != 0) {
                                            window.scrollBy(0, scrollStep);
                                        }
                                        else
                                            clearInterval(scrollInterval);
                                    }, 15);
                                }
                            }, (error) => {
                                this.clicked = false;
                                this.orderMessage = error.error['message'];
                                if (this.orderMessage === 'USER_DAILY_LIMIT_EXCEEDED' ||
                                    this.orderMessage === 'USER_WEEKLY_LIMIT_EXCEEDED' ||
                                    this.orderMessage === 'USER_MONTHLY_LIMIT_EXCEEDED') {
                                    this.limitValue = error.error['value'];
                                }
                            });
                        }
                    }
                }
            }
        });
    }
};
CreateTransactionComponent.ctorParameters = () => [
    { type: SharedHttp },
    { type: Router },
    { type: AuthService },
    { type: PaymentService },
    { type: SpinnerService },
    { type: WebClientService },
    { type: DomSanitizer },
    { type: WebsiteThemeService },
    { type: UtilityService },
    { type: EcurrenciesService }
];
__decorate([
    ViewChild('selectSpecial')
], CreateTransactionComponent.prototype, "selectSpecial", void 0);
__decorate([
    ViewChild('orderForm')
], CreateTransactionComponent.prototype, "orderForm", void 0);
__decorate([
    ViewChild('buyForm')
], CreateTransactionComponent.prototype, "buyForm", void 0);
__decorate([
    HostListener('document:click', ['$event'])
], CreateTransactionComponent.prototype, "onDocumentClick", null);
CreateTransactionComponent = __decorate([
    Component({
        selector: 'ecd-guest-component',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./create-transaction.component.html")).default
    })
], CreateTransactionComponent);
export { CreateTransactionComponent };
